import { Stack } from '@src/shared/ui/layout';
import type { ReactNode } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <Stack spacing={1}>
      <Header />
      <Stack direction="row" spacing={1.25}>
        {children}
        <Sidebar />
      </Stack>
    </Stack>
  );
}
